import { Tags } from '@ppvrbh/merchant-frontend-core';
import { FoodCategory } from './food-category';
export interface MenuDiscount {
  menuDiscountId: number;
  priceDiscount: number;
  menuDiscountStatus: string;
  startDate: string;
  endDate?: string | null;
}
export class FoodMenu {
  menuId?: number;
  menuName?: string;
  menuNameEN?: string;
  menuSKUId?: string;
  menuDescription?: string;
  menuDescriptionEN?: string;
  menuOriginalPrice?: number;
  menuPhoto?: string;
  menuPrice?: number;
  menuStatus?: string;
  menuQCStatus?: string;
  menuQCUpdatedDate?: string;
  menuRejectReason?: [];
  menuCategory?: FoodCategory;
  menuDiscounts?: MenuDiscount[];
  menuModifierGroups?: MenuModifierGroup[];
  tagId?: number;
  tag?: Tags;

  constructor(Obj: any = {}) {
    this.menuId = Obj.menuId;
    this.menuName = Obj.menuName;
    this.menuNameEN = Obj.menuNameEN;
    this.menuSKUId = Obj.menuSKUId;
    this.menuDescription = Obj.menuDescription;
    this.menuDescriptionEN = Obj.menuDescriptionEN;
    this.menuOriginalPrice = Obj.menuOriginalPrice;
    this.menuPhoto = Obj.menuPhoto;
    this.menuPrice = Obj.menuPrice;
    this.menuStatus = Obj.menuStatus;
    this.menuQCStatus = Obj.menuQCStatus;
    this.menuQCUpdatedDate = Obj.menuQCUpdatedDate;
    this.menuRejectReason = Obj.menuRejectReason;
    this.menuCategory = Obj.menuCategory;
    this.menuDiscounts = Obj.menuDiscounts;
    this.menuModifierGroups = Obj.menuModifierGroups;
    this.tagId = Obj.tagId;
    this.tag = Obj.tag;
  }
}

export enum MenuQCStatusEnum {
  APPROVED = "MNQC-APPROVE",
  REJECTED = "MNQC-REJECT",
  NEW = "MNQC-NEW",
}

export interface FoodMenuType {
    menuId: number;
    tagId: number;
    menuSequence: number;
    menuName: string;
    menuNameEN: string
    menuSKUId: string;
    menuDescription: string;
    menuDescriptionEN: string;
    menuPhotoUrl: string;
    menuPrice: number;
    menuOriginalPrice: number;
    menuStatus: string;
    menuQCStatus: MenuQCStatusEnum;
    menuRejectReason: string[]
    qcUpdatedAt: string;
    menuCategory: MenuCategory;
    menuDiscounts: MenuDiscount[];
    isHideMenu: boolean;
    isOffline: boolean;
    startDate: string;
    endDate: string;
    menuPhoto?: string;
}

export interface MenuCategory {
    menuCategoryId: number;
    menuCategoryTypeId: number;
    menuCategoryName: string;
    menuCategoryNameEN: string;
    menuCategoryStatus: string
}

export type MenuModifierGroup = {
  menuModifierGroupId: number;
  menuModifierGroupName: string;
  menuModifierGroupNameEN: string;
}

export type PaginationResponse = {
  totalItems: number;
  itemCount: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;
}


export type MenuInCatType = MenuCategory & {
  menus: {
    items: (FoodMenuType & MenuModifierGroup)[];
    total: number;
    meta : PaginationResponse
  };
};
